import platform from 'platform'

// URL list
import URL from '../../../config.url'


// Required for multi-pages website
import router from './Router'


// Mixins
import CoreScroll from '../../mixins/core-scroll'
import CoreRAF from '../../mixins/core-raf'


// Pages
import PageHome from '../page-home'
import PageNews from '../page-news'
import PageArticle from '../page-article'
import PageSponsors from '../page-sponsors'
import PageTeams from '../page-teams'
import PageTeamProfile from '../page-team-profile'
import PageVideos from '../page-videos'
import PageVideoPlayer from '../page-video-player'
import PageWatchNow from '../page-watch-now'
import PageAbout from '../page-about'
import PageMatches from '../page-matches'
import PageMatchDetails from '../page-match-details'
import PagePlayer from '../page-player'
import PageStandings from '../page-standings'
import PageCopyright from '../page-copyright'
import PagePolicy from '../page-policy'
import PageTerms from '../page-terms'
import Page404 from '../page-404'
import PageDebug from '../page-debug'
import PageIntraVideo from '../page-intra-video'
import PageInformations from '../page-informations'
import PageSeason from '../page-season'
import PageGallery from '../page-gallery'


// Components
import AppHeader from '../app-header'
import AppFooter from '../app-footer'
import AppImgBg from '../app-img-bg'
import AppBg from '../app-bg'
import AppModalRegister from '../app-modal-register'
import AppModalVideo from '../app-modal-video'
import AppLoader from '../app-loader'
import AppFloatingLive from '../app-floating-live'


import Gateway from '../../utils/global/Gateway'
import Support from '../../utils/global/Support'
import Equation from '../../utils/math/Equation'


const support = new Support()


export default
{
    router,

    name: 'app-main',

    watch:
    {
        $route: '_onRouteChange',
        contentGlobal: '_onContentGlobalChange',
        contentPage: '_onContentPageChange'
    },

    mixins:
    [
        CoreScroll,
        CoreRAF
    ],

    components:
    {
        PageHome,
        PageNews,
        PageArticle,
        PageSponsors,
        PageTeams,
        PageTeamProfile,
        PageVideos,
        PageVideoPlayer,
        PageWatchNow,
        PageCopyright,
        PageTerms,
        PagePolicy,
        PageAbout,
        PageMatches,
        PageMatchDetails,
        PagePlayer,
        PageStandings,
        Page404,
        PageDebug,
        PageInformations,
        PageIntraVideo,
        PageGallery,
        PageSeason,

        AppHeader,
        AppFooter,
        AppImgBg,
        AppBg,
        AppModalRegister,
        AppModalVideo,
        AppLoader,
        AppFloatingLive
    },

    data()
    {
        return {
            componentId: null,
            contentGlobal: null,
            contentPage: null,
            params: null,
            languagesSupported: null,

            isLoading: 0,

            registerIsOpen: false,
            registerTypeSlug: 'default',
            registerObserveId: '',

            videoIsOpen: false,
            videoType: '',
            videoId: '',
            videoUrl: '',

            pageHeight: 0, // for menu open

            // Bind with other components, don't change his label
            isTouch: ['Android', 'iOS', 'Windows Phone'].indexOf(platform.os.family) !== -1,
            isFakeScroll: ['Android', 'iOS', 'Windows Phone'].indexOf(platform.os.family) === -1,

            // Live
            isChannelLive: false,
            isChannelLiveResponse: null,
            isFloatingLiveShown: true,
            isWatchNow: false,

            // Sizes
            width: 0,
            height: 0,

            // Scroll
            scrollTopTweenY: 0,
            scrollTopRealY: 0,

            // Internationalisation
            // i11n
            lang: null
        }
    },

    created()
    {
        console.log('%cGFINITY%c Elite Series%c',
            'color: #e62932; font-size: x-large; font-weight: bold;',
            'color: #040404; font-size: x-large; ',
            'color: #4f4f4f; font-size: x-small')

        console.log('%cBack framework %cSilex', 'color: #4f4f4f;', 'color: #e62932;')
        console.log('%cFront framework %cVue.js', 'color: #4f4f4f;', 'color: #e62932;')
        console.log('%cFront library %cThree.js', 'color: #4f4f4f;', 'color: #e62932;')

        this.isLoading = 1
        this._pageHeight = 0
        this._footerHeight = 0

        this.getSupportedLanguages()

        // Run page
        this._onRouteChange(this.$route)

        // Listen menu (mobile) events
        this.eventHub.$on('menu-opened', this._onMenuForceResize)
        this.eventHub.$on('menu-closed', this._onMenuDisableResize)

        this.eventHub.$on('toggle:is-floating-live-shown', this._toggleIsFloatingLiveShown)


        // Check API connection: Disable in production
        // this._testAPI()
    },

    mounted()
    {
        // Will containt all the page and simulate fake scroll
        this._container = this.$el.querySelector('.js-container')

        // Set sizes variables
        this.width = window.innerWidth
        this.height = window.innerHeight
    },

    methods:
    {
        // ---------------------------
        //
        //      TOGGLE

        _toggleIsFloatingLiveShown(value)
        {
            if (value && typeof value === 'boolean')
            {
                this.isFloatingLiveShown = value
            }
            else if (this.isFloatingLiveShown)
            {
                this.isFloatingLiveShown = false
            }
            else if (!this.isFloatingLiveShown)
            {
                this.isFloatingLiveShown = true
            }
        },

        // ---------------------------
        //
        //      MODALS

        openModalPlay(registerTypeSlug, registerObserveId = '')
        {
            this.registerTypeSlug = registerTypeSlug
            this.registerObserveId = registerObserveId
            this.registerIsOpen = true
        },

        closeModalPlay()
        {
            this.registerIsOpen = false
        },

        openModalVideo(type, id, url)
        {
            this.videoType = type
            this.videoId = id
            this.videoUrl = url
            this.videoIsOpen = true

            this.eventHub.$emit('application:on-open-modal-video')
        },

        closeModalVideo()
        {
            this.videoIsOpen = false

            this.eventHub.$emit('application:on-close-modal-video')
        },


        // ---------------------------
        //
        //      API TEST

        _testAPI()
        {
            Gateway.getInstance().send(
                this.getAPIURLWithLangFromID('test'),
                data =>
                {
                    console.log('%cAPI%c connected', 'color: #4f4f4f;', 'color: #129725;')
                },
                msg =>
                {
                    console.error('%cAPI%c not connected (' + msg + ')', 'color: #4f4f4f;', 'color: #e62932;')
                })
        },


        // ---------------------------
        //
        //      SCROLL

        getScrollY()
        {
            return this.isFakeScroll ? this.scroll.smoothY : this.scroll.realY
        },

        instantScrollTo(y)
        {
            window.scrollTo(0, y)
            this.scroll.reset(y)
        },

        scrollTo(y)
        {
            this._isScrollTween = true
            this._scrollTweenData = {
                startTime: Date.now(),
                startY: this.scroll.realY,
                endTime: Date.now() + 2000,
                endY: y,
                equation: Equation.easeInOutQuint
            }
        },

        _scrollTween()
        {
            const data = this._scrollTweenData
            const now = Date.now()
            let y

            if (now >= data.endTime)
            {
                y = data.endY

                this._isScrollTween = false
                this._scrollTweenData = null
            }
            else
            {
                const t = now - data.startTime
                y = data.equation(t, data.startY, data.endY - data.startY, data.endTime - data.startTime)
            }

            window.scrollTo(0, y)
        },

        onFrame() // dt, time
        {
            this.eventHub.$emit('application:on-frame')

            if (this._isScrollTween)
            {
                this._scrollTween()
            }
        },

        onScroll(y)
        {
            this.scrollTopRealY = this.scroll.realY
            this.scrollTopTweenY = this.scroll.smoothY

            if (this.isFakeScroll && this._container)
            {
                const rule = 'translateY(' + (-y).toFixed(0) + 'px) translateZ(0)'
                this._container.style.transform = rule
            }
        },


        // ---------------------------
        //
        //      RESIZE

        _onMenuForceResize(menuHeight)
        {
            this._headerHeight = menuHeight + this._headerMatches.offsetHeight
            this._menuSizePriority = true
            this._setDocumentHeight()
        },

        _onMenuDisableResize()
        {
            this._menuSizePriority = false
            this._setDocumentHeight()
        },

        _onPageResized(componentPage)
        {
            this._pageHeight = componentPage.$el.offsetHeight

            this._setDocumentHeight()

            this.width = window.innerWidth
            this.height = window.innerHeight
        },

        _onFooterResized()
        {
            if (!this._footer)
            {
                this._footer = this.$el.querySelector('.js-footer')
            }

            this._footerHeight = this._footer.offsetHeight
            this._setDocumentHeight()
        },

        _setDocumentHeight()
        {
            if (this._menuSizePriority)
            {
                document.body.style.height = this._headerHeight + 'px'
                this.pageHeight = this._headerHeight
            }
            else
            {
                document.body.style.height = (this._pageHeight + this._footerHeight) + 'px'
                this.pageHeight = 0
            }
        },


        // ---------------------------
        //
        //      ROUTE

        changePage(url = '/')
        {
            this.$router.push(url)
        },

        getPageURLFromID(id, options = {})
        {
            const optionsKeys = Object.keys(options)
            let url = URL.page[id].replace(':lang', this.lang)

            if (optionsKeys.length > 0)
            {
                for (let i = 0, l = optionsKeys.length; i < l; i += 1)
                {
                    if (options[optionsKeys[i]])
                    {
                        url = url.replace(`:${optionsKeys[i]}`, options[optionsKeys[i]])
                    }
                }
            }

            return url
        },

        _onRouteChange(to) // to, from
        {
            this._getLang()

            // Use unstrict comparator because:
            // undefined != null => false
            // undefined !== null => true

            // Define variable if it's Watch Now page to disable floating live
            this.isWatchNow = to.meta.component === 'page-watch-now'

            if (this.componentId != to.meta.component
                || (to.params && to.params.slug != this._currentSlug)
                || (to.params && to.params.lang != this.lang))
            {
                if (to.meta.component !== this.componentId || to.meta.component === 'page-season' || to.meta.component === 'page-team-profile' || to.meta.component === 'page-player' || to.meta.component === 'page-article')
                {
                    // Check each time user changes page
                    this.checkIfChannelIsLive()

                    this.isLoading++
                    setTimeout(this._routeChange, 1000, to)
                }
            }
            else
            {
                this.params = JSON.parse(JSON.stringify(to.params))
            }
        },

        _routeChange(to)
        {
            // console.log('%cPage %c' + to.path, 'color: #4f4f4f;', 'color: #e62932;')

            this.registerIsOpen = false
            this.contentPage = null
            this.componentId = to.meta.component
            this.params = to.params ? (JSON.parse(JSON.stringify(to.params)) || { }) : { }

            this.eventHub.$emit('route:change', to)


            const getData = { }


            // Remove scroll tween
            this._isScrollTween = false


            // Send only slug param to API
            if (this.params.slug)
            {
                getData.slug = this.params.slug
                this._currentSlug = this.params.slug
            }
            else
            {
                this._currentSlug = null
            }

            Gateway.getInstance().send(
                this.getAPIURLWithLangFromID(to.meta.key),
                this._onContentLoaded,
                this._onContentError,
                getData)
        },

        _getLang()
        {
            let navigatorLang = this.$route.params.lang

            if (typeof navigatorLang === 'undefined'
                || this.languagesSupported.indexOf(navigatorLang) === -1)
            {
                navigatorLang = navigator.language || navigator.userLanguage

                // If navigatorLang is not supported
                // Set language to first language supported
                if (this.languagesSupported.indexOf(navigatorLang) === -1)
                {
                    navigatorLang = this.languagesSupported[0]
                }
            }

            this.lang = navigatorLang

            // Redirect when language is not supported
            if (this.lang !== this.$route.path.split('/').filter(n => n !== '')[0])
            {
                const url = this.$route.path
                const urlSplitted = url.split('/').filter(n => n !== '')
                const urlLang = urlSplitted[0]

                if (urlLang)
                {
                    this.changePage(url.replace(`/${urlLang}`, `/${this.lang}`))
                }
                else
                {
                    this.changePage(`/${this.lang}`)
                }
            }
        },

        _updateAnalytics(meta)
        {
            // Google Analytics
            // ga('set', { page: this.$route.path, title: meta.title })
            // ga('send', 'pageview')

            if (this.$route.meta.disableTracking)
            {
                console.log('%cTracking disabled for this page', 'color: #e62932;')
            }
            // Google tag manager
            else if (window.dataLayer)
            {
                window.dataLayer.push({
                    event: 'gfinity.vpv',
                    'gfinity.vpv.path': this.$route.path
                })
            }
            else
            {
                console.error('Google Tag Manager: dataLayer not defined')
            }
        },


        // ---------------------------
        //
        //      CONTENT (JSON)

        getSupportedLanguages()
        {
            this.languagesSupported = ['uk', 'au']

            this._getLang()

            this._refreshContent(1000 * 60 * 30)  // 1000 * 60 * 30 = 30mn
            // Gateway.getInstance().send(
            //     this.getAPIURLWithLangFromID('base'),
            //     response =>
            //     {
            //         // TODO : Remove when APIwill be built
            //         this.languagesSupported = ['uk', 'au']
            //         //
            //
            //         this._getLang()
            //
            //         // Refresh global data
            //         this._refreshContent(1000 * 60 * 30)  // 1000 * 60 * 30 = 30mn
            //     },
            //     error =>
            //     {
            //         this.languagesSupported = ['uk', 'au']
            //
            //         this._getLang()
            //
            //         // Refresh global data
            //         this._refreshContent(1000 * 60 * 30)  // 1000 * 60 * 30 = 30mn
            //         console.error(error)
            //     })
        },

        getAPIURLWithLangFromID(key)
        {
            return URL.api[key].replace(':lang', this.lang)
        },

        // Refresh for header
        _refreshContent(time)
        {
            Gateway.getInstance().send(
                this.getAPIURLWithLangFromID('global'),
                this._onContentGlobalLoaded,
                this._onContentGlobalError)

            setTimeout(this._refreshContent, time, time)
        },

        _onContentGlobalLoaded(data)
        {
            this.contentGlobal = data

            // Update only first time
            if (!this._headerMatches)
            {
                this.isLoading--

                this.$nextTick(() =>
                {
                    this._headerMatches = this.$el.querySelector('.js-header-matches')
                })
            }
        },

        _onContentGlobalError(message)
        {
            this.isLoading--
            this.contentGlobal = {} // todo: delete this line
            console.error(message)
        },

        _onContentLoaded(data)
        {
            this.isLoading--
            this.contentPage = data

            this.instantScrollTo(0)

            this._updatePageMeta(data.meta)

            if (!this._pagesHistoryNum)
            {
                this._pagesHistoryNum = 0
            }
            else
            {
                this._updateAnalytics(data.meta)
            }

            this._pagesHistoryNum++
        },

        _onContentError(message)
        {
            this.isLoading--
            this.contentPage = null
            console.error(message)

            // Redirect to 404 page
            const data404 = router.options.routes.find(route => route.path === URL.page[404])
            this._onRouteChange(data404)
        },

        _updatePageMeta(meta = { title: '', description: '' })
        {
            document.title = meta.title || 'Gfinity'

            const descriptionTag = document.querySelector('meta[name=description]')
            if (descriptionTag && (meta.description || '').trim() !== '')
            {
                descriptionTag.setAttribute('content', meta.description || 'Welcome to the home of Esports! Watch the best teams and players in the world of Esports battle each other across three games to become Gfinity Elite Series champions.')
            }
        },

        _onContentGlobalChange()
        {
            // Each time contentGlobal or contentpage are changing
            // If both are initialized, check if a live is playing
            if (this.contentGlobal && this.contentPage)
            {
                this.checkIfChannelIsLive()
            }
        },

        _onContentPageChange()
        {
            // Each time contentGlobal or contentpage are changing
            // If both are initialized, check if a live is playing
            if (this.contentGlobal && this.contentPage)
            {
                this.checkIfChannelIsLive()
            }
        },

        checkIfChannelIsLive()
        {
            // Check if channel is live via Twitch API
            Gateway.getInstance().send(
                `https://api.twitch.tv/kraken/streams/${this.contentGlobal.twitch.channel}?client_id=${this.contentGlobal.twitch.id}`,
                response =>
                {
                    // Basic verification from twitch
                    if (!response.stream)
                    {
                        this.isChannelLive = false
                        this.isChannelLiveResponse = null
                    }
                    else
                    {
                        this.isChannelLive = true
                        this.isChannelLiveResponse = response
                    }
                },
                error =>
                {
                    this.isChannelLive = false
                    this.isChannelLiveResponse = null
                    console.error(`Error to get if the channel is live: ${error}`)
                })
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-main/script.js